import React from 'react';

type TabOption = {
  label: string;
  value: string;
};

type TabSelectorProps = {
  options: TabOption[];
  selected: string;
  onChange: (value: string) => void;
};

const TabSelector: React.FC<TabSelectorProps> = ({ options, selected, onChange }) => (
  <div className="flex flex-wrap gap-6 items-center">
    {options.map((tab) => (
      <button
        key={tab.value}
        type="button"
        className={`text-lg font-medium pb-1 border-b-2 transition-colors ${
          selected === tab.value ? 'text-ow-blue border-ow-blue' : 'text-black border-transparent'
        }`}
        onClick={() => onChange(tab.value)}
        aria-selected={selected === tab.value}
      >
        {tab.label}
      </button>
    ))}
  </div>
);

export default TabSelector;
